import './App.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import SearchContainer from './containers/SearchContainer';
import { StateProvider } from './state';
import { getCurrentEnv, getClientByDomain } from './helpers/index';

const getClientSideID = () => {

	const clientIds = {
		"local": "5fdb8437f294fc0a9aef9add",
		"dev": "5fdb8437f294fc0a9aef9add",
		"development": "5fdb8437f294fc0a9aef9add",
		"beta": "5fdb83b0f294fc0a9aef9abb",
		"staging": "5fdb840151479b0ae4bb2f41",
		"production": "5fdb83b0f294fc0a9aef9abc"
	}

	let env = 'local';

	try {
		env = getCurrentEnv();
	} catch (ex) {
		env = 'local';
	}

	if (Object.prototype.hasOwnProperty.call(clientIds, env) === false) {
		return clientIds['production'];
	}

	return clientIds[env];
}

const getClient = () => {
	let client = 'AOL';

	try {
		client = getClientByDomain();
	} catch (ex) {
		client = 'AOL'
	}

	return client;
}

const SearchWithState = ({ clientCode, isPreview }) => (
	<StateProvider client={clientCode} isPreview={isPreview}>
		<SearchContainer />
	</StateProvider>
);

SearchWithState.propTypes = {
	clientCode: PropTypes.string,
	isPreview: PropTypes.bool,
};

const App = (props) => {
	if (props.isSSR) {
		return (
			<div id="search-root">
				<SearchWithState {...props} />
			</div>
		);
	} else {
		return (
			<SearchWithState {...props} />
		)
	}
};

export default withLDProvider({
	clientSideID: getClientSideID(),
	user: {
		key: getClient()
	}
})(App);
